import React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    SelectInput,
    ReferenceInput,
    ReferenceArrayInput,
    SelectArrayInput,
    ChipField,
    BooleanInput,
    FormDataConsumer,
} from 'react-admin';
import { Grid, Paper, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { usePermissions } from 'react-admin';
import RenderTree from './RenderTree';
import { ROLE_ADMIN, isInRole } from '../authProvider';

const wItems = {
	width: '75%',
    padding: '1em'
}
const wContainer = {
	width: '100%'
}


const HEXSelectorUserEdit = (props) => {
    const { permissions } = usePermissions();
    const isAdmin = isInRole(ROLE_ADMIN, permissions);
    return (
        <Edit {...props} style={wContainer} >
            <SimpleForm redirect="/users" >
                <Grid container justifyContent="space-between" spacing={2}  style={wItems}>
                    <Grid item container direction="column"  xs={3}>
                        <h2>Basic Settings</h2>
                        <TextInput source="email" label="Email" disabled={true} />
                        <TextInput source="lastSeenVersion" label="Version" disabled={true} />
                        <ReferenceInput label="License status" source="licenseStatus" reference="HEXSelector/LicenseStatuses">
                            <SelectInput optionText="name" />
                        </ReferenceInput>
                        <ReferenceInput label="License" source="segmentsId" reference="HEXSelector/SegmentCollections" perPage={1000} sort={{ field: 'name', order: 'ASC' }}>
                            <SelectInput optionText="name" />
                        </ReferenceInput>
                        {isAdmin ?
                        <ReferenceInput label="User Group (Plate List)" source="plateListId" reference="HEXSelector/PlateLists" perPage={1000} sort={{ field: 'name', order: 'ASC' }}>
                            <SelectInput optionText="name" />
                        </ReferenceInput>
                        : null}
                        {isAdmin ? 
                        <ReferenceInput label="OEM" source="oemId" reference="HEXSelector/OEM" sort={{ field: 'name', order: 'ASC' }}>
                            <SelectInput optionText="name" />
                        </ReferenceInput>
                        : null}
                        {isAdmin ?
                        <ReferenceInput label="Release Branch" source="releaseBranch" reference="HEXSelector/ReleaseBranches">
                            <SelectInput optionText="name" />
                        </ReferenceInput>
                        : null }
                        <ReferenceInput label="Discount Approval Level" source="discountUserLevelId" reference="HEXSelector/DiscountUserLevels" sort={{ field: 'name', order: 'ASC' }}>
                            <SelectInput optionText="name" />
                        </ReferenceInput>
                        <h2>Regional Settings</h2>
                        <ReferenceArrayInput source="regionalSettingsDeliveryConceptIds" label="Delivery Concept" reference="HEXSelector/RegionalSettings/DeliveryConcepts" sort={{ field: 'name', order: 'ASC' }}>
                            <SelectArrayInput >
                                <ChipField source="name"></ChipField>
                            </SelectArrayInput>
                        </ReferenceArrayInput>
                        <ReferenceArrayInput source="regionalSettingsCustomPortfolioIds" label="Custom Portfolio" reference="HEXSelector/RegionalSettings/CustomPortfolios" sort={{ field: 'name', order: 'ASC' }}>
                            <SelectArrayInput >
                                <ChipField source="name"></ChipField>
                            </SelectArrayInput>
                        </ReferenceArrayInput>
                        <ReferenceArrayInput source="regionalSettingsLocalPriceListIds" label="Local Price List" reference="HEXSelector/RegionalSettings/LocalPriceLists" sort={{ field: 'name', order: 'ASC' }}>
                            <SelectArrayInput >
                                <ChipField source="name"></ChipField>
                            </SelectArrayInput>
                        </ReferenceArrayInput>
                        {isAdmin ? 
                        <ReferenceArrayInput source="regionalSettingsFluidListIds" label="Fluid List" reference="HEXSelector/RegionalSettings/FluidLists" sort={{ field: 'name', order: 'ASC' }}>
                            <SelectArrayInput > 
                                <ChipField source="name"></ChipField>
                            </SelectArrayInput>
                        </ReferenceArrayInput>
                        : null }
                    </Grid>
                    <Grid container direction="column" item xs={3}>
                        <Paper>
                            <h2>Details</h2>
                            <FormDataConsumer>
                                {({ formData, ...rest }) => RenderTree('HEXSelector/SegmentCollectionsTree', formData.segmentsId) }
                            </FormDataConsumer>
                            {isAdmin ?
                            <FormDataConsumer>
                                {({ formData, ...rest }) => RenderTree('HEXSelector/PlateListsTree', formData.plateListId)}
                            </FormDataConsumer>
                            : null }
                        </Paper>
                    </Grid>
                    <Grid container direction="column" item xs={3}>
                        <h2>Program Settings</h2>
                        {isAdmin ? 
                        <div>
                            <BooleanInput source="exemptFromVersionCheck" label="Exempt from Version Enforcement" />
                        </div>
                         : null}
                        {isAdmin ? 
                        <div>
                            <BooleanInput source="enablePandoraEditor" label="Full Pandora Editor" />
                            <FormDataConsumer>
                                {({ formData, ...rest }) => !formData.enablePandoraEditor &&
                                    <BooleanInput source="enableGeneralPandoraEditor" label="General Pandora Editor" {...rest} />
                                }
                            </FormDataConsumer>
                            <BooleanInput source="isExternalUser" label="External User" />
                        </div>
                         : null }
                        <BooleanInput source="enableFluidEditor" label="Fluid Editor" />
                        <BooleanInput source="enableAdvancedDataSheet" label="Advanced Data Sheet" />
                        {isAdmin ? <BooleanInput source="ahriTestVersion" label="AHRI Test Version" /> : null}
                        {isAdmin ? <BooleanInput source="ahriExcelExport" label="AHRI Excel Export" /> : null}
                        {isAdmin ? <BooleanInput source="enableCustomizedExports" label="Enable Customized Exports" /> : null}
                        {isAdmin ?
                        <div>
                            <h3>Temporary until HEXSelector is fixed</h3>
                            <BooleanInput source="enableGlobalPriceList" label="Prices: User can see prices and Price List" />
                            <BooleanInput source="enableNewSalePriceList" label="Price List: Enable New Sale/Accessories (requires acces to Prices)" />
                        </div>
                        : null }
                        <h2>GHEX</h2>
                        <BooleanInput source="ghexPrices" label="GHEX Prices" />
                        <BooleanInput source="ghexNewSalePriceList" label="Price List: Enable New Sale/Accessories (requires acces to Prices)" />
                        {isAdmin ?
                        <div>
                            <BooleanInput source="enableOneERPExport" label="Enable One ERP model code export" />
                            <BooleanInput source="enableOneERPExportAHRI" label="Enable One ERP model code export (AHRI)" />
                            <BooleanInput source="enableAComponentOnly" label="A Delivery Concept Only" />
                            <BooleanInput source="enableGHEXExoticMaterials" label="GHEX Exotic Materials" />
                            <BooleanInput source="enableGHEXHistoricalPrices" label="GHEX Historical Prices" />
                            <BooleanInput source="enableGHEXResearchAndDevelopment" label="GHEX R&amp;D Features" />
                            <BooleanInput source="enableGHEXCost" label="GHEX Costing (View)" />
                            <BooleanInput source="enablePlatePandoraFactors" label="Can Edit Plate Pandora Factors" />
                            <BooleanInput source="enablePlatePandoraTestUser" label="Plate Pandora Factors Test User" />
                            <FormDataConsumer>
                                {({ formData, ...rest }) => formData.enableGHEXCost &&
                                    <BooleanInput source="enableGHEXCostEdit" label="GHEX Costing (Edit)" {...rest} />
                                }
                            </FormDataConsumer>
                        </div>
                        : null }
                    </Grid>
                    <Grid container direction="column" item xs={3}>
                        <h2>BHEX</h2>
                        <BooleanInput source="bhexPrices" label="BHEX Prices" />
                        <BooleanInput source="bhexNewSalePriceList" label="Price List: Enable New Sale/Accessories (requires acces to Prices)" />
                        {isAdmin ? <BooleanInput source="enableBHEXTailorMade" label="BHEX Tailor Made" /> : null}
                        <h2>SW</h2>
                        <BooleanInput source="swPrices" label="SW Prices" />
                        <BooleanInput source="swNewSalePriceList" label="Price List: Enable New Sale/Accessories (requires acces to Prices)" />
                        <BooleanInput source="irfExternal" label="IRF External" />
                        {isAdmin ? <BooleanInput source="irfExportRatingDetails" label="IRF Export Rating Details" /> : null}
                        {isAdmin ?
                        <div>
                            <h2>CC</h2>
                            <BooleanInput source="enableCommercialCoolingResearchAndDevelopment" label="CC R&amp;D Features" />
                        </div>
                        : null }

                    </Grid>
                </Grid>
                {isAdmin ? 
                <Accordion style={{ width: "100%"}}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <b>Account Change History</b>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{ width: "100%"}}>
                            <FormDataConsumer>
                                {({ formData, ...rest }) => RenderTree('HEXSelector/Users/History', formData.id)}
                        </FormDataConsumer>
                        </div>
                    </AccordionDetails>
                </Accordion>
                : null }
            </SimpleForm>
        </Edit>
    );
}

export default HEXSelectorUserEdit;